import { urlFor } from "@/utils/client";
import { IMeta, ISettings } from "@/utils/types";
import Head from "next/head";
import { Header } from "./header";

export function Meta({ data, settings }: { data: IMeta, settings: ISettings }) {

    // Format the keywords to be comma-separated
    const formattedKeywords = data.keywords ? data.keywords.split(/\s+/).join(", ") : "";

    return (
        <>
            <Head>
                <title>{data.title}</title>
                <meta name="description" content={data.description} />
                <link rel="shortcut icon" href="/favicon.png" />
                {data.image && (
                    <meta
                        property="og:image"
                        content={urlFor(data.image).url()}
                    />
                )}
                {data.keywords && <meta name="keywords" content={formattedKeywords} />}
                {data.noIndex && <meta name="robots" content="noindex" />}
            </Head>
            <Header data={settings} />
        </>
    );
}
